// extracted by mini-css-extract-plugin
export var container = "_ir-0";
export var content = "_ir-3";
export var customerTitle = "_ir-4";
export var empty = "_ir-5";
export var gray = "_ir-6";
export var header = "_ir-7";
export var info = "_ir-8";
export var loading = "_ir-2";
export var loadingCard = "_ir-9";
export var oneLine = "_ir-a";
export var personName = "_ir-e";
export var pillContainer = "_ir-b";
export var selected = "_ir-1";
export var text = "_ir-c";
export var twoLines = "_ir-d";
export var unread = "_ir-f";
export var unreadIndicator = "_ir-g";